<template>
  <div class="border-top">
    <SOFilterTitle title="Metode Top Up" :diterapkan="diterapkan" :id="id"/>
    <div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
      <SOInputCheckbox
          :checkboxes="metodeTopup"
          :checked="filterItem.metodeTopup"
          @selected="selected"
      />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
  name: "SOFilterMetodeTopup",
  components: {
    SOFilterTitle,
    SOInputCheckbox,
  },
  props: {
    id: String,
  },
  computed: {
    ...mapGetters("filterGlobalModule", {
      filterItem: "getFilterItem"
    })
  },
  mounted() {
    this.diterapkan = this.filterItem.metodeTopup.length > 0
  },
  watch: {
    "filterItem.metodeTopup": {
      handler: function () {
        this.diterapkan = this.filterItem.metodeTopup.length > 0
      }
    }
  },
  data() {
    return {
      checked: [],
      metodeTopup: {
        name: "metode-topup",
        data: [
          {
            id: "f-metode-top-up-reguler",
            value: 'reguler',
            title: "Reguler di outlet",
            checked: false,
            titleBold: false,
          },
          {
            id: "f-metode-top-up-loyalty",
            value: 'loyalty',
            title: "Loyalty Apps",
            checked: false,
            titleBold: false,
          },
        ]
      },
      diterapkan: false,
    }
  },
  methods: {
    selected(val) {
      let temp = this.filterItem
      temp.metodeTopup = val
      this.$store.commit("filterGlobalModule/setFilterItem", temp)
      this.diterapkan = this.filterItem.metodeTopup.length > 0
    }
  }
}
</script>